import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    "palette": {
        "secondary": {
            "main": "#304FFE",
            "light": "#536DFE",
            "dark": "#1A237E"
        },
        "primary": {
            "main": "#304FFE",
            "light": "#536DFE",
            "dark": "#1A237E"
        },
        "background": {
            "default": "#FFF",
            "emphasis": "#E8EAF6",
            "secondary": "#C5CAE9",
            "header": "#121037"
        },
        "text": {
            "primary": "#1A237E",
            "secondary": "#5C6BC0",
            "hint": "#9FA8DA"
        },
        "contrastThreshold": 1.8
    },
    "shadows": [
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none",
        "none"
    ]
});

export default theme;

